// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100%;
  width: 100%;
}

.chat-footer-sticky-component-mode {
  background-color: white;
  bottom: 0;
  right: 0;
  max-height: 75px;
  position: fixed;
  width: 100%;
  border-top: 1px solid var(--bg-color);
}

.background-mode-component {
  background: #ffffff;
  padding: 4px 6px;
}

.main-container-mode-component {
  height: calc(100% - 75px);
  width: 100%;
}

.main-container-mode-component-mobile {
  height: 400px !important;
  width: 100%;
}

.back-button-container {
  position: absolute;
  top: 65px;
  left: 20px;
  z-index: 9999;
  background: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.back-button-container .back-icon {
  font-size: 30px;
  cursor: pointer;
}

.input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.upload-btn-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px;
}
.upload-btn-wrapper label {
  display: flex;
}

.input-wrap {
  padding: 5px;
  display: flex;
  width: 100%;
  margin: auto;
  background: #fff;
  border-top: 1px solid #ECEAF3;
}
.input-wrap textarea {
  flex: 1;
  border: 0;
  border-bottom: 1px rgba(0, 0, 0, 0.3);
  border-style: solid;
  font-family: var(--font);
  font-weight: 400;
}
.input-wrap .divider {
  width: 1px;
  height: 23px;
  background: rgba(32, 17, 87, 0.09);
  margin-right: 10px;
  margin-left: 4px;
}
.input-wrap .send-btn {
  border-radius: 28px;
  height: 44px;
  min-width: 44px;
}
.input-wrap .send-btn span {
  display: none;
  text-transform: none;
  color: #FFF;
  margin: 0 10px;
  font-family: var(--font);
  font-weight: 700;
}

.pre-send-img-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px 0px;
  width: 100%;
  position: relative;
  border-top: 2px solid var(--bg-color);
  background: #fff;
}
.pre-send-img-container button {
  position: absolute;
  left: 0;
  top: 5px;
  width: 2rem;
  height: 2rem;
  background: transparent;
  font-size: 1.5rem;
}

.pre-send-img-pic {
  height: 30%;
  max-height: 200px;
  object-fit: cover;
}

.background {
  position: relative;
}

.visio-message-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.visio-message-container .call-received-icon,
.visio-message-container .call-exit-icon {
  font-size: 25px;
  margin: auto;
}
.visio-message-container .message-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  font-family: var(--font);
  font-weight: 600;
}
.visio-message-container .call-icon {
  background: rgba(149, 150, 188, 0.28);
  width: 43px;
  height: 43px;
  display: flex;
  margin-right: 12px;
}

.btn-join-visio {
  min-height: 32px;
  border-radius: 28px;
  padding: 7px 16px;
  color: white;
  cursor: pointer;
  font-family: var(--font);
  font-weight: 700;
}

.icon-camera {
  font-size: 25px;
  cursor: pointer;
  margin-right: 10px;
}

.icon-camera:hover {
  opacity: 0.9;
}

.line-breaker {
  white-space: pre-line;
}

a.line-breaker {
  cursor: pointer;
  pointer-events: all;
}

.icon-not-send {
  color: rgba(0, 0, 0, 0.3);
  font-size: 26px;
  cursor: pointer;
}

.send-icon {
  cursor: pointer;
}

.no-msgs {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-chat {
  width: 100%;
  margin: 0 auto;
}

.msg-wrap {
  padding: 5px 10px;
  margin-bottom: 76px;
}
.msg-wrap .connected-usr-msg .msg-text {
  justify-self: end;
  border-radius: 19px 19px 0 19px;
}
.msg-wrap .connected-usr-msg .msg-time {
  justify-self: end;
}
.msg-wrap .other-usr-msg .msg-text {
  border-radius: 19px 19px 19px 0;
}
.msg-wrap .msg-item {
  display: grid;
  grid-template-columns: 32px auto;
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 12px;
  margin-top: 18px;
}
.msg-wrap .msg-item .sender-img {
  width: 32px;
  height: 32px;
  align-self: end;
}
.msg-wrap .msg-item .sender-img .profile-picture {
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
  background: var(--bg-color);
  width: 32px;
  height: 32px;
  padding: 8px;
}
.msg-wrap .msg-item .sender-img .profile-picture .cus-picture {
  width: 16px;
  height: 16px;
  opacity: 0.6;
}
.msg-wrap .msg-item .msg-text {
  background: var(--bg-color);
  min-height: 38px;
  padding: 11px 17px;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 16px;
  font-family: var(--font);
  font-weight: 600;
  max-width: 80%;
  word-break: break-word;
  white-space: pre-line;
  grid-column: 2;
}
.msg-wrap .msg-item .msg-sender {
  grid-column: 2;
  font-size: 10px;
  font-family: var(--font);
  font-weight: 300;
  max-width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.msg-wrap .msg-item .msg-time {
  grid-column: 2;
  margin: 4px 0;
  font-family: var(--font);
  font-weight: 300;
  font-size: 12px;
}

.container-no-content-chat {
  position: relative;
}
.container-no-content-chat > .wait-content {
  position: absolute;
  top: 15px;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.3rem;
}
.container-no-content-chat ion-icon {
  height: 300px;
  width: 100%;
}
.container-no-content-chat .text-empty-content {
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: auto;
  text-align: center;
  font-family: var(--font);
}
.container-no-content-chat .text-empty-content .title {
  font-weight: 600;
  font-size: 17px;
  margin-bottom: 10px;
}

@media screen and (min-width: 768px) {
  .input-wrap {
    width: 70%;
  }
  .input-wrap .send-btn span {
    display: block;
  }
  .chat-footer-sticky-component-mode {
    width: 28%;
    bottom: 0;
  }
  .toolbar-bottom-border ion-title {
    text-align: left;
  }
  .pre-send-img-container {
    width: 70%;
    margin: auto;
  }
  .container-no-content-chat ion-icon {
    height: 440px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/chat/chat.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;AACJ;;AAIA;EAEI,uBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EAEA,eAAA;EACA,WAAA;EACA,qCAAA;AAHJ;;AAMA;EAEI,mBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,wBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAJJ;AAMI;EACI,eAAA;EACA,eAAA;AAJR;;AAQA;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AALJ;;AAQA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AALJ;AAOI;EACI,aAAA;AALR;;AASA;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;AANJ;AAOI;EACI,OAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;EACA,wBAAA;EAA0B,gBAAA;AAJlC;AAMI;EACI,UAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AAJR;AAMI;EACI,mBAAA;EACA,YAAA;EACA,eAAA;AAJR;AAKQ;EACI,aAAA;EACA,oBAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EAA0B,gBAAA;AAFtC;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;AAJJ;AAKI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;AAHR;;AAOA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,kBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AAJJ;AAMI;;EAEI,eAAA;EAEA,YAAA;AALR;AAQI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wBAAA;EAA0B,gBAAA;AALlC;AAOI;EACI,qCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AALR;;AASA;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EAA0B,gBAAA;AAL9B;;AAQA;EACI,eAAA;EACA,eAAA;EACA,kBAAA;AALJ;;AAQA;EACI,YAAA;AALJ;;AAQA;EACI,qBAAA;AALJ;;AAQA;EACI,eAAA;EACA,mBAAA;AALJ;;AAQA;EACI,yBAAA;EACA,eAAA;EACA,eAAA;AALJ;;AAQA;EACI,eAAA;AALJ;;AAkIA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA/HJ;;AAkIA;EAGI,WAAA;EACA,cAAA;AAjIJ;;AAsIA;EACI,iBAAA;EACA,mBAAA;AAnIJ;AAqIQ;EACI,iBAAA;EACA,+BAAA;AAnIZ;AAqIQ;EACI,iBAAA;AAnIZ;AAuIQ;EACI,+BAAA;AArIZ;AAwII;EACI,aAAA;EACA,gCAAA;EACA,mCAAA;EACA,qBAAA;EACA,gBAAA;AAtIR;AAuIQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;AArIZ;AAsIY;EACI,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AApIhB;AAqIgB;EACI,WAAA;EACA,YAAA;EACA,YAAA;AAnIpB;AAuIQ;EACI,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AApIZ;AAuIQ;EACI,cAAA;EACA,eAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AApIZ;AAsIQ;EACI,cAAA;EACA,aAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAnIZ;;AAuIA;EACI,kBAAA;AApIJ;AAqII;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,iBAAA;AAlIR;AAoII;EACI,aAAA;EACA,WAAA;AAlIR;AAoII;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;AAlIR;AAmIQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AAjIZ;;AAqIA;EAEI;IACI,UAAA;EAnIN;EAqIU;IACI,cAAA;EAnId;EAuIE;IACI,UAAA;IACA,SAAA;EArIN;EAyIM;IACI,gBAAA;EAvIV;EA0IE;IACI,UAAA;IACA,YAAA;EAxIN;EA2IM;IACI,aAAA;EAzIV;AACF","sourcesContent":[":host {\n    height: 100%;\n    width: 100%;\n}\n\n// Component mode part\n\n.chat-footer-sticky-component-mode {\n    // position: sticky;\n    background-color: white;\n    bottom: 0;\n    right: 0;\n    max-height: 75px;\n    // width: 100%;\n    position: fixed;\n    width: 100%;\n    border-top: 1px solid var(--bg-color);\n}\n\n.background-mode-component {\n    // height: 100%;\n    background: #ffffff;\n    padding: 4px 6px;\n}\n\n.main-container-mode-component {\n    height: calc(100% - 75px);\n    width: 100%;\n}\n\n.main-container-mode-component-mobile {\n    height: 400px !important;\n    width: 100%;\n}\n\n.back-button-container {\n    position: absolute;\n    top: 65px;\n    left: 20px;\n    z-index: 9999;\n    background: #f6f6f6;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n\n    .back-icon {\n        font-size: 30px;\n        cursor: pointer;\n    }\n}\n\n.input-file {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n}\n\n.upload-btn-wrapper {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0px 10px;\n\n    label {\n        display: flex;\n    }\n}\n\n.input-wrap {\n    padding: 5px;\n    display: flex;\n    width: 100%;\n    margin: auto;\n    background: #fff;\n    border-top: 1px solid #ECEAF3;\n    textarea {\n        flex: 1;\n        border: 0;\n        border-bottom: 1px rgba(0, 0, 0, 0.3);\n        border-style: solid;\n        font-family: var(--font); font-weight: 400;;\n    }\n    .divider{\n        width: 1px;\n        height: 23px;\n        background: rgb(32 17 87 / 0.09);\n        margin-right: 10px;\n        margin-left: 4px;\n    }\n    .send-btn{\n        border-radius: 28px;\n        height: 44px;\n        min-width: 44px;\n        span{\n            display: none;\n            text-transform: none;\n            color: #FFF;\n            margin: 0 10px;\n            font-family: var(--font); font-weight: 700;;\n        }\n    }\n}\n\n.pre-send-img-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 20px 0px;\n    width: 100%;\n    position: relative;\n    border-top: 2px solid var(--bg-color);\n    background: #fff;\n    button{\n        position: absolute;\n        left: 0;\n        top: 5px;\n        width: 2rem;\n        height: 2rem;\n        background: transparent;\n        font-size: 1.5rem;\n    }\n}\n\n.pre-send-img-pic {\n    height: 30%;\n    max-height: 200px;\n    object-fit: cover;\n}\n\n.background {\n    position: relative;\n}\n\n.visio-message-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n\n    .call-received-icon,\n    .call-exit-icon {\n        font-size: 25px;\n        // margin-right: 20px;\n        margin: auto;\n    }\n\n    .message-container {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: space-between;\n        font-family: var(--font); font-weight: 600;;\n    }\n    .call-icon{\n        background: rgb(149 150 188 / 0.28);\n        width: 43px;\n        height: 43px;\n        display: flex;\n        margin-right: 12px;\n    }\n}\n\n.btn-join-visio {\n    min-height: 32px;\n    border-radius: 28px;\n    padding: 7px 16px;\n    color: white;\n    cursor: pointer;\n    font-family: var(--font); font-weight: 700;;\n}\n\n.icon-camera {\n    font-size: 25px;\n    cursor: pointer;\n    margin-right: 10px;\n}\n\n.icon-camera:hover {\n    opacity: 0.9;\n}\n\n.line-breaker {\n    white-space: pre-line;\n}\n\na.line-breaker {\n    cursor: pointer;\n    pointer-events: all;\n}\n\n.icon-not-send {\n    color: rgba(0, 0, 0, 0.3);\n    font-size: 26px;\n    cursor: pointer;\n}\n\n.send-icon {\n    cursor: pointer;\n}\n\n// .message-wrap {\n//     padding: 5px 10px;\n//     width: 100%;\n//     // min-height: 100%;\n//     // height: 100%;\n//     // height: 500px;\n//     height: calc(100vh - 76px);\n//     // overflow: auto;\n//     position: relative;\n//     margin-bottom: 76px;\n//     .message {\n//         position: relative;\n//         padding: 7px 0;\n//         outline: none !important;\n\n//         .user-img {\n//             position: absolute;\n//             border-radius: 45px;\n//             object-fit: cover;\n//             object-position: center;\n//             width: 45px;\n//             height: 45px;\n//             box-shadow: 0 0 2px rgba(0, 0, 0, 0.36);\n//         }\n\n//         .msg-detail {\n//             width: 100%;\n//             display: inline-block;\n\n//             p {\n//                 margin: 0;\n//             }\n\n//             .msg-info {\n//                 p {\n//                     font-size: 0.8em;\n//                     color: #888;\n//                 }\n//             }\n\n//             .msg-content {\n//                 position: relative;\n//                 margin-top: 5px;\n//                 border-radius: 5px;\n//                 padding: 8px;\n//                 border: 1px solid #ddd;\n//                 color: #1f1f1f;\n//                 width: auto;\n//                 max-width: 80%;\n//             }\n\n//             .msg-picture {\n//                 width: 100%;\n//                 margin: 0 auto;\n//                 display: block;\n//                 border-radius: 10px;\n//                 height: 130px;\n//                 object-fit: cover;\n//                 margin-bottom: 5px;\n//             }\n//         }\n//     }\n\n//     .message.left {\n//         .msg-content {\n//             background-color: rgba(224, 247, 245, 0.3);\n//             float: left;\n//         }\n\n//         .msg-detail {\n//             padding-left: 60px;\n//         }\n\n//         .user-img {\n//             left: 0;\n//             object-fit: cover;\n//         }\n\n//         .msg-content {\n//             color: #343434;\n\n//             span.triangle {\n//                 border-top-width: 0;\n//                 border-right-width: 0;\n//                 left: -5px;\n//             }\n//         }\n//     }\n\n//     .message.right {\n//         .msg-detail {\n//             padding-right: 60px;\n\n//             .msg-info {\n//                 text-align: right;\n//             }\n//         }\n\n//         .user-img {\n//             right: 0;\n//         }\n\n//         ion-spinner {\n//             position: absolute;\n//             right: 10px;\n//             top: 50px;\n//         }\n\n//         .msg-content {\n//             background-color: #eafae0;\n//             float: right;\n\n//             span.triangle {\n//                 background-color: #eafae0;\n//                 border-bottom-width: 0;\n//                 border-left-width: 0;\n//                 right: -5px;\n//             }\n//         }\n//     }\n// }\n\n.no-msgs {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.footer-chat {\n    // background-color: var(--bg-color-content);\n    // padding: 0 7px;\n    width: 100%;\n    margin: 0 auto;\n    // position: fixed;\n    // bottom: 0px;\n}\n\n.msg-wrap{\n    padding: 5px 10px;\n    margin-bottom: 76px;\n    .connected-usr-msg{\n        .msg-text{\n            justify-self: end;\n            border-radius: 19px 19px 0 19px ;\n        }\n        .msg-time{\n            justify-self: end;\n        }\n    }\n    .other-usr-msg{\n        .msg-text{\n            border-radius: 19px 19px 19px 0;\n        }\n    }\n    .msg-item{\n        display: grid;\n        grid-template-columns: 32px auto;\n        grid-template-rows: repeat(2, auto);\n        grid-column-gap: 12px;\n        margin-top: 18px;\n        .sender-img{\n            width: 32px;\n            height: 32px;\n            align-self: end;\n            .profile-picture{\n                border-radius: 50%;\n                object-fit: cover;\n                object-position: center;\n                margin: 0 auto;\n                background: var(--bg-color);\n                width: 32px;\n                height: 32px;\n                padding: 8px;\n                .cus-picture{\n                    width: 16px;\n                    height: 16px;\n                    opacity: 0.6;\n                }\n            }\n        }\n        .msg-text{\n            background: var(--bg-color);\n            min-height: 38px;\n            padding: 11px 17px;\n            width: fit-content;\n            font-size: 16px;\n            font-family: var(--font); font-weight: 600;;\n            max-width: 80%;\n            word-break: break-word;\n            white-space: pre-line;  \n            grid-column: 2;\n\n        }\n        .msg-sender{\n            grid-column: 2;\n            font-size: 10px;\n            font-family: var(--font); font-weight: 300;;\n            max-width: 80%;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n        .msg-time{\n            grid-column: 2;\n            margin: 4px 0;\n            font-family: var(--font); font-weight: 300;;\n            font-size: 12px;\n        }\n    }\n}\n.container-no-content-chat{\n    position: relative;\n    >.wait-content{\n        position: absolute;\n        top: 15px;\n        left: 0;\n        width: 100%;\n        text-align: center;\n        font-family: var(--font); font-weight: 600;;\n        font-size: 1.3rem;\n    }\n    ion-icon{\n        height: 300px;\n        width: 100%;\n    }\n    .text-empty-content {\n        height: 70px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        margin: auto;\n        text-align: center;\n        font-family: var(--font);\n        .title{ \n            font-weight: 600;\n            font-size: 17px;\n            margin-bottom: 10px;\n        }\n    }\n}\n@media screen and (min-width: 768px) {\n\n    .input-wrap {\n        width: 70%;\n        .send-btn{\n            span{\n                display: block;\n            }\n        }\n    }\n    .chat-footer-sticky-component-mode {\n        width: 28%;\n        bottom: 0;\n    }\n    .toolbar-bottom-border{\n        // border-radius: 37px;\n        ion-title{\n            text-align: left;\n        }\n    }\n    .pre-send-img-container{\n        width: 70%;\n        margin: auto;\n    }\n    .container-no-content-chat{\n        ion-icon{\n            height: 440px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
